import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
// WelcomePage no longer used
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CompaniesPage from './pages/CompaniesPage';
import DealsPage from './pages/DealsPage';
import DealDetailsPage from './pages/DealDetailsPage';
import CustomersPage from './pages/CustomersPage';
import EditDealPage from './pages/EditDealPage';
import PrivateRoute from './auth/PrivateRoute';
import { AuthProvider } from './auth/AuthContext';
// RegisterPage removed
import Layout from './components/Layout';
import PipelinePage from "./pages/PipelinePage";
import AdminRoute from "./auth/AdminRoute";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminAnalysisReportsPage from "./pages/AdminAnalysisReportsPage";
import AdminConfigurationPage from "./pages/AdminConfigurationPage";
import AdminMcpPage from "./pages/AdminMcpPage";
import { ToastProvider } from "./components/ui/ToastContext";

// Component to handle Azure redirect hash - must be inside Router
function AzureRedirectHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  
  React.useEffect(() => {
    // If there's a hash with code or error (Azure redirect) and we're NOT on root
    if (window.location.hash && (window.location.hash.includes('code=') || window.location.hash.includes('error='))) {
      if (location.pathname !== '/') {
        // Navigate to / but keep the hash - use window.location to preserve hash
        window.location.replace('/' + window.location.hash);
      } else {
        // already on root path, hash preserved
      }
    }
  }, [navigate, location.pathname]);
  
  return null;
}

// Wrapper to ensure redirect handler is inside Router
function AppRoutes() {
  return (
    <>
      <AzureRedirectHandler />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {/* Support legacy /login path to avoid blank pages when code redirects there */}
        <Route path="/login" element={<LoginPage />} />
        {/* Invite acceptance flow removed */}
        {/* /register route removed (RegisterPage deleted) */}
        <Route path="/pipeline" element={
          <PrivateRoute>
            <Layout activePage="pipeline">
              <PipelinePage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/dashboard" element={
          <PrivateRoute>
            <Layout activePage="dashboard">
              <DashboardPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/companies" element={
          <PrivateRoute>
            <Layout activePage="companies">
              <CompaniesPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/deals" element={
          <PrivateRoute>
            <Layout activePage="deals">
              <DealsPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/deal-details/:id" element={
          <PrivateRoute>
            <Layout activePage="deals">
              <DealDetailsPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/deals/edit/:id" element={
          <PrivateRoute>
            <Layout activePage="deals">
              <EditDealPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/customers" element={
          <PrivateRoute>
            <Layout activePage="customers">
              <CustomersPage />
            </Layout>
          </PrivateRoute>
        } />

        {/* Admin Panel */}
        <Route
          path="/admin/users"
          element={
            <AdminRoute>
              <Layout activePage="admin-users">
                <AdminUsersPage />
              </Layout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/analysis-reports"
          element={
            <AdminRoute>
              <Layout activePage="admin-analysis">
                <AdminAnalysisReportsPage />
              </Layout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/configuration"
          element={
            <AdminRoute>
              <Layout activePage="admin-configuration">
                <AdminConfigurationPage />
              </Layout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/mcp"
          element={
            <AdminRoute>
              <Layout activePage="admin-mcp">
                <AdminMcpPage />
              </Layout>
            </AdminRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
